module.exports = __webpack_public_path__ + "static/img/bcg.df1fcf7f.webp";